<template>
  <!-- 医生详情展示页面 主要用来展示 没复杂功能 -->
  <div id="doctor-msg">
    <div class="back-wrapper">
      <img src="../../assets/img/common-img/backic@2x.png" alt="" class="back-icon" @click="goBack">
    </div>
    <div class="content-box">
      <div class="doctor-box">
        <div class="box-top">
          <!-- <div class="top-left">
            <img src="../../assets/img/see-doctor-icon/1-3tuijian@2x.png" alt="" class="famous-top">
            <img :src="doctorData.image" alt="" class="doctor-icon">
            <img src="../../assets/img/see-doctor-icon/good-doctor@2x.png" alt="" class="famous-bottom">
          </div>-->
          <div class="doctor-left">
            <img
              src="../../assets/img/see-doctor-icon/1-3tuijian@2x.png"
              alt=""
              class="good-icon"
              v-if="doctorData.is_famous_doctor !== 'n'"
            >
            <img :src="doctorData.image" alt="" class="doctor-icon" @click="showDoctor">
            <img
              src="../../assets/img/see-doctor-icon/good-doctor@2x.png"
              alt=""
              class="good-doc"
              v-if="doctorData.is_famous_doctor !== 'n'"
            >
          </div>
          <div class="top-right">
            <div class="doctor-name">
              <span class="name-text">{{doctorData.name}}</span>
              <div class="doctor-skill">
                <span>{{doctorData.title}}</span>
              </div>
            </div>
            <div class="doctor-hospital">
              <span>{{doctorData.hospital}}</span>
              <span>{{doctorData.clinic_name}}</span>
            </div>
            <div class="doctor-tips">
              <span
                class="tips-wrapper"
                v-if="doctorData && index<3"
                v-for="(item,index) in doctorData.tags"
                :key="index"
              >{{doctorData.tags[index]}}</span>
            </div>
          </div>
          <div class="like" @click="addLike(doctorData.doctor_id)">
            <img src="../../assets/img/see-doctor-icon/unlike.png" alt="" v-if="!islike">
            <img src="../../assets/img/see-doctor-icon/isliked.png" alt="" v-if="islike">
          </div>
        </div>
        <div class="box-bottom">
          <div class="doctor-hot">
            <span class="hot-num">{{doctorData.reply_num}}</span>
            <span class="hot-name">咨询人次</span>
          </div>
          <span class="flag">|</span>
          <div class="doctor-hot">
            <span class="hot-num">{{doctorData.good_rate}}%</span>
            <span class="hot-name">好评率</span>
          </div>
        </div>
      </div>
      <div class="doctor-message">
        <ul class="message-box">
          <div class="message-title">
            <img src="../../assets/img/askdoctor/jianjie@2x.png" alt="" class="title-icon">
            <span class="title-name">医生简介</span>
          </div>
          <li class="message-item">
            <span class="item-text">{{doctorData.achievement}}</span>
          </li>
        </ul>
        <ul class="message-box">
          <div class="message-title">
            <img src="../../assets/img/askdoctor/shanchang1@2x.png" alt="" class="title-icon">
            <span class="title-name">擅长领域</span>
          </div>
          <li class="message-item">
            <span class="item-text">{{doctorData.good_at}}</span>
          </li>
        </ul>
        <ul class="message-box">
          <div class="message-title">
            <img src="../../assets/img/askdoctor/fuwu@2x.png" alt="" class="title-icon">
            <span class="title-name">服务说明</span>
          </div>
          <li class="message-item">
            <span class="item-text">医生会尽快回复您，如遇特殊情况会有所延迟；</span>
          </li>
          <li class="message-item">
            <span class="item-text">超过4小时未回复将自动退款；</span>
          </li>
          <li class="message-item">
            <span class="item-text">{{severText}}</span>
          </li>
        </ul>
      </div>
      <div class="other-video">
        <div class="other-sorts border-css">
          <p class="other-name title-css" v-if="relatedDiseases">相关视频</p>
          <div class="scroll-box">
            <ul class="item-wrapper">
              <li class="item-list" v-for="(item,index) in relatedDiseases" :key="index">
                <div class="img-box" @click="goGroupDetail(item)">
                  <!-- relatedDiseases -->
                  <img :src="item.item_info.aliyun_cover_url" alt="" class="list-img">
                  <span class="tips">{{item.episode_text}}</span>
                </div>
                <span class="list-name">{{item.group_name}}</span>
                <div class="video-shdow-wrapper" @click="goGroupDetail(item)">
                  <img src="../../assets/img/common-img/bgc-img.png" alt="" class="video-shdow">
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部支付按钮 -->
    <div class="bottom">
      <div class="box-bottom">
        <div class="bottom-button">
          <van-button
            size="large"
            class="right-button"
            @click="goRouter('/SdInquiry',doctorData.doctor_id)"
          >立即咨询（{{doctorData.price/100}}元/次）</van-button>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<script>
  import { ImagePreview } from 'vant';
  import api from '@/api/index'
  export default {
    data() {
      return {
        doctorId: "",
        doctorData: {},
        relatedDiseases: [],
        goodAt: [],
        doctorEdu: [],
        departId: null,
        islike: false,
        imagesDoctor: [
          'https://img.yzcdn.cn/1.jpg',
        ],
        fid: []
      };
    },
    created() {
      if (this.$route.query.doctorId) {
        this.doctorId = this.$route.query.doctorId;
      } else {
        this.doctorId = 0;
      }
    },
    mounted() {
      this.fetch();
      this.hasSee();
    },
    methods: {
      // 查看医生头像
      showDoctor() {
        ImagePreview({
          images: this.imagesDoctor,
          closeOnPopstate: true
        })
      },
      // 添加到“浏览过的医生”
      hasSee(){
        let params = {
          doctor_id: this.doctorId,
          type: 2
        };
        let url = `${api.addCollectDoctor}?doctor_id=${params.doctor_id}&type=${params.type}`;
        this.$http.get(url).then(res=>{
          console.log(res)
        })
      },
      // 检查是否收藏医生
      isliked() {
        this.$http
          .post(
            api.doctorCollectCheck,
            this.$ObjToFd({
              doctor_id: this.doctorId,
              type: 1
            })
          )
          .then(res => {
            console.log(res, "收藏情况")
            if (res.data.error) {
              this.$toast(res.data.message);
            }
            this.islike = res.data.data
            this.fid = res.data.fid
          });
      },
      // 收藏医生
      addLike(id) {
        // js hook写法
        let likemsg = ["取消收藏", "收藏成功"]
        let flagLink = [api.doctorCollectAdd, api.deleteCollectDoctor]
        let req = [{ 'doctor_id': id, 'type': 1 }, { 'fids': this.fid }]
        this.$http
          .post(
            flagLink[+this.islike],
            this.$ObjToFd(req[+this.islike])
          )
          .then(res => {
            if (!res.data.error) {
              this.islike = !this.islike;
              this.$toast(likemsg[+this.islike]);
            } else {
              this.$toast(res.data.message);
            }
          });
      },
      goRouter(val, id, famous) {
        this.$router.push({ path: val, query: { doctor_id: id } });
      },
      goBack() {
        this.$router.back(-1);
      },
      fetch() {
        let params = {
          doctor_id: this.doctorId
        };
        this.isliked()
        let url = `${api.doctorDetail}?doctor_id=${params.doctor_id}`;
        this.$http.get(url).then(res => {
          if (res.data.code == "0") {
            console.log(res, "我是医生详情");
            this.doctorData = res.data.data;
            this.imagesDoctor[0] = res.data.data.image
            this.goodAt = this.doctorData.good_at.split(";");
            this.doctorEdu = this.doctorData.education.split(";");
            this.departId = res.data.data.department_id;
            let params = {
              department_id: this.departId
            };
            let url = `${api.relatedDisease}?department_id=${
              params.department_id
            }`;
            this.$http.get(url).then(res => {
              console.log(res, "我是视频详情的相关视频");
              if (res.data.code == "0") {
                this.relatedDiseases = res.data.data;
              }
            });
          }
        });
      },
      // 相关视频去视频详情(已废弃)
      goVideo(val) {
        this.$router.push({
          path: "/SdDetailVideo",
          query: { itemId: val.item_info.item_id }
        });
      },
      // 相关专题(相关视频)
      goGroupDetail(val) {
        // 由于跳转的是当前页面，this.$router.push不会更新当前组件
        this.$router.push("/SdGroupDetail?itemId=" + val.item_info.item_id);
        // location.reload();
        // this.fetch() //直接监听路由
      }
    },
    computed: {
      severText() {
        return this.doctorData.is_famous_doctor === "y"
          ? "48小时以内可以与医生互动咨询10次（从您提出问题，到医生回复计为一次互动咨询）。"
          : "48小时以内可以与医生互动咨询50次（从您提出问题，到医生回复计为一次互动咨询）。";
      }
    }
  };
</script>

<style lang="postcss" scoped>
  #doctor-msg {
    /* padding: 0 30px; */
    padding-bottom: 60px;
    background-color: #fffffd;
    & .back-wrapper {
      position: fixed;
      width: 100%;
      height: 88px;
      top: 0;
      z-index: 9999;
      background-color: #fffffd;
      display: flex;
      align-items: center;
      & .back-icon {
        width: 16px;
        height: 32px;
        position: absolute;
        left: 30px;
      }
    }
    & .content-box {
      padding: 0 30px;
      padding-top: 80px;
      padding-bottom: 88px;
      background-color: #fffffd;
    }
    & .doctor-box {
      margin-top: 15px;
      height: 352px;
      background: rgba(255, 255, 253, 1);
      box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      padding: 30px 0 0 30px;
      box-sizing: border-box;
      /* margin-bottom: 60px; */
      & .box-top {
        display: flex;
        position: relative;
        & .top-left {
          position: relative;
          & .doctor-icon {
            border-radius: 50%;
            width: 120;
            height: 120px;
            border: 1px solid #ccc;
            z-index: 555;
          }
          & .famous-top {
            position: absolute;
            width: 58px;
            height: 79px;
            left: 0;
            top: 0;
            z-index: 1;
          }
          & .famous-bottom {
            position: absolute;
            width: 120px;
            height: 41px;
            bottom: 0px;
          }
        }
        & .doctor-left {
          width: 170px;
          position: relative;
          & .doctor-icon {
            width: 120px;
            height: 120px;
            z-index: 666;
            position: absolute;
            border-radius: 50%;
            border: 1px solid #ddd;
          }
          & .good-icon {
            position: absolute;
            width: 53px;
            height: 72px;
            left: -10px;
            top: -30px;
            z-index: 555;
          }
          & .good-doc {
            width: 120px;
            height: 41px;
            position: absolute;
            top: 100px;
            z-index: 777;
          }
        }
        & .top-right {
          width: 600px;
          & .doctor-name {
            display: flex;
            align-items: center;
            font-size: 30px;
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            & .doctor-skill {
              margin-left: 20px;
              display: flex;
              font-size: 26px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              & span {
                margin: 0 10px;
              }
            }
          }
          & .doctor-hospital {
            font-size: 26px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin: 16px 0 20px 0;
            & span:last-child {
              color: rgba(153, 153, 153, 1);
            }
          }
          & .doctor-tips {
            font-size: 20px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(55, 189, 25, 1);
            & .tips-wrapper {
              padding: 5px 15px;
              background: rgba(55, 189, 25, 0.1);
              border-radius: 15px;
              margin: 10px 10px 10px 0;
            }
          }
        }
        & .like {
          position: absolute;
          top: -12px;
          right: -6px;
          & img {
            /* margin-top: -12px;
            width: 154px; */
            width: 50px;
            margin: 0px 24px 0 0;
          }
        }
      }
      & .box-bottom {
        margin-top: 80px;
        display: flex;
        /* align-items: center; */
        justify-content: space-around;
        & .doctor-hot {
          display: flex;
          flex-direction: column;
          align-items: center;
          & .hot-num {
            height: 27px;
            font-size: 36px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(55, 189, 25, 1);
          }
          & .hot-name {
            margin-top: 20px;
            font-size: 24px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
          }
        }
        & .flag {
          height: 33px;
          color: rgba(215, 215, 215, 1);
          transform: scaleX(.5);
        }
      }
    }
    & .doctor-message {
      & .message-box {
        margin-top: 60px;
        & .message-title {
          position: relative;
          display: flex;
          align-items: center;
          padding-bottom: 26px;
          margin-bottom: 20px;
          & .title-name {
            font-size: 30px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          & .title-icon {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
        & .message-title::after {
          position: absolute;
          bottom: 0;
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          border: 1px solid rgba(215, 215, 215, 1);
          transform: scaleY(.3);
        }
        & .message-item {
          font-size: 26px;
          font-family: SourceHanSansCN-Regular;
          color: #666;
          line-height: 48px;
        }
      }
    }
    & .other-video {
    }
    & .other-sorts {
      margin-top: 50px;
      & .scroll-box {
        overflow: hidden;
      }
      & .item-wrapper {
        padding: 20px;
        margin: -20px;
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        display: flex;
        width: 99%;
        & .item-list {
          position: relative;
          width: 100%;
          margin-right: 30px;
          /* overflow: hidden; */
          & .img-box {
            margin: 30px 0;
            width: 320px;
            height: 200px;
            border-radius: 10px;
            overflow: hidden;
            position: relative;
            & .list-img {
              width: 320px;
              height: 200px;
            }
            & .tips {
              position: absolute;
              bottom: 10px;
              right: 10px;
              font-size: 18px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              z-index: 222;
            }
          }
          & .list-name {
            font-size: 28px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          & .video-shdow-wrapper {
            width: 100%;
            height: 100%;
            z-index: 1;
            position: absolute;
            bottom: 60px;
            & .video-shdow {
              width: 100%;
              height: 150px;
              position: absolute;
              bottom: -16px;
              z-index: 1;
            }
          }
        }
      }
      & .item-wrapper::-webkit-scrollbar {
        display: none;
      }
    }
    & .bottom {
      position: fixed;
      bottom: 0px;
      width: 100%;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      z-index: 99999;
      & .box-bottom {
        & .van-button--default {
          height: 88px;
          background-color: #ffffff;
          border: none;
          font-size: 32px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(55, 189, 25, 1);
        }
      }
    }
  }
</style>
<style>
  .van-overlay.van-image-preview__overlay {
    z-index: 999999 !important;
  }
  .van-image-preview {
    z-index: 1000000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduAskDoctor/SdDoctorMsg.vue